import styled from "styled-components";
import {Avatar} from "antd";
import {Link} from "react-router-dom";

export const MarkerContainer = styled.div`
    position: absolute;
    border-radius: 50%;
    width: 20px;
    max-height: 20px;
    background-color: ${props => props.color};
    transform: translate(-48%, -115%) rotate(45deg);
    border: 1px solid
        ${props => (props.color === "#4C9E7D" || props.color === "#D85E5A" ? "white" : "black")};
    box-sizing: content-box;
    cursor: pointer;
    border-bottom-right-radius: 2%;
    z-index: ${props => props.zIndex};
`;

export const MarkerIcon = styled(Avatar)`
    width: 20px;
    height: 20px;
    background-color: transparent;
    color: ${props => (props.color === "#4C9E7D" || props.color === "#D85E5A" ? "white" : "black")};
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 14px !important;
    transform: rotate(-45deg);
`;

export const SubCompanyContainer = styled.div`
    position: absolute;
    transform: translate(-48%, -115%) rotate(45deg);
    z-index: ${props => props.zIndex};
`;

export const SubCompanyIcon = styled.img`
    width: 20px;
    height: 24.1px;
    transform: rotate(-45deg);
`;

export const BulletText = styled.div`
    color: ${props => props.color && props.color};
    font-weight: ${props => (props.thick ? "bold" : "normal")};
    margin-left: ${props => props.alter && 10}px;
    &:before {
        content: ${props => (props.alter ? `"-"` : `"•"`)};
        margin-right: 10px;
    }
`;

export const CourierImg = styled.img`
    width: 95px;
    border-radius: 4px;
`;

export const InfoLink = styled(Link)`
    color: black;
    margin-left: 20px;
`;

export const PointerIcon = styled.div`
    margin-right: 10px;
`;

export const TooltipText = styled.p`
    margin-right: 3px;
    margin-bottom: 0px;
    &:after {
        content: "•";
        margin-left: 3px;
    }
    &:last-child:after { 
        content: "";
      }
`;
